/* Christmas in a Bottle: page logic. Ported from the approved localhost preview (preview-msgbottle/index.html: menu, gallery,
   tiers, sticky bar, drawer) with its in-memory preview cart swapped for Shopify's cart, the same way assets/prism.js does it.
   Every number comes from window.BOTTLE, which sections/bottle-main.liquid builds from the real variants, so the page can never
   quote a price Shopify won't bill (STORE-BUILD-LESSONS §1). The cart is Shopify's: /cart.js, /cart/add.js, /cart/update.js,
   /cart/change.js. The four wallet buttons and Checkout go to /checkout.

   CART RULES
   - One bottle line, quantity 1, always the chosen tier's variant (the tier IS the quantity). Add replaces any other bottle line,
     so two bottles always bill The Pair price, never 2 x The Single.
   - The bottle line's stepper (Julian 2026-10-21: "up and down quantity and delete, just like the Heirloom Tree kit"): the kit
     stepper's look, but the number is BOTTLES and +/- SWAP the line's tier (1 The Single, 2 The Pair, 3 The Family Set) with the
     same add-first-then-clear write as Add, never quantity 2. Plus is disabled at three; at one bottle the minus is the delete
     icon. The picker follows the drawer. A cart that holds more than one bottle line, or a line at quantity > 1, is made one
     line on load: the tier for all its bottles, capped at three (normalizeBottles).
   - Every write is decided on a FRESH /cart.js read (another tab, Back from checkout, a first read still in flight).
   - After a write the cart is read again; if Shopify bills a different price than the button showed (prices changed after this
     page loaded) the page says so and reloads instead of opening the drawer or going to checkout.
   - Shipping protection is the live store's add-on product (handle shipping-protection, its own price). With one bottle it is an
     optional add-on, never pre-ticked. With 2 or 3 bottles it is included free: the bottle line carries the line-item property
     "Shipping protection: Included free" (shown in checkout and on the order), the drawer shows it struck through to Free,
     the paid add-on is hidden, and a paid protection line already in the cart is taken out, so nobody pays for what the page
     calls free.
   - Add-ons never ride alone and are one per order (as in prism.js and hh-cart.js). */
(function () {
  'use strict';
  var P = window.BOTTLE; if (!P) return;
  var D = document, B = D.body;
  function $(id) { return D.getElementById(id); }
  function qsa(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  function smooth() { return mq('(prefers-reduced-motion: reduce)') ? 'auto' : 'smooth'; }
  function focusOn(el) { if (el) try { el.focus({ preventScroll: true }); } catch (e) {} }
  function money(c) {                              // cents in, "$1,234.56" out (the store's money format is ${{amount}})
    c = Math.round(Number(c) || 0); var a = Math.abs(c);
    return (c < 0 ? '−' : '') + '$' + Math.floor(a / 100).toLocaleString('en-US') + '.' + ('0' + (a % 100)).slice(-2);
  }
  qsa('.ms').forEach(function (el) { el.setAttribute('aria-hidden', 'true'); });
  /* v28: /cart (hh-cart.js) shows this drawer's free-gifts line on the bottle line too, but only while this section's "Show the free
     gifts" setting is on, and it has no way to read that setting itself. So every load of this page leaves it in localStorage:
     'hh_bottle_gifts' = '1:<time>' or '0:<time>'. /cart ignores a missing or day-old mark (no gift line). */
  try { window.localStorage.setItem('hh_bottle_gifts', (P.showGifts ? '1' : '0') + ':' + Date.now()); } catch (e) {}

  var toast = $('toast'), tt;
  function say(msg, ms) { if (!toast || !msg) return; toast.textContent = msg; toast.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('on'); }, ms || 3600); }

  /* ---------- All products menu ---------- */
  var apBtn = $('apBtn'), apPanel = $('apPanel');
  if (apBtn && apPanel) {
    var setAp = function (open) { apBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); apPanel.hidden = !open; };
    apBtn.addEventListener('click', function (e) { e.stopPropagation(); setAp(apPanel.hidden); });
    D.addEventListener('click', function (e) { if (!apPanel.hidden && !apPanel.contains(e.target)) setAp(false); });
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !apPanel.hidden) { setAp(false); apBtn.focus(); } });
    var apHere = apPanel.querySelector('[aria-current="page"]');
    if (apHere) apHere.addEventListener('click', function (e) { e.preventDefault(); setAp(false); window.scrollTo({ top: 0, behavior: smooth() }); });
  }

  /* ---------- the three tiers, straight from the variants (cents) ---------- */
  var T = {};
  [1, 2, 3].forEach(function (k) {
    var t = P.tiers && P.tiers[k];
    if (t && t.id) T[k] = { id: Number(t.id), n: Number(t.n) || k, name: String(t.name || ''), line: String(t.line || ''),
                            price: Number(t.price) || 0, compare: Number(t.compare) || 0, available: t.available !== false };
  });
  var SINGLE = T[1] ? T[1].price : 0;
  /* regular price: The Single = its compare-at if above its price; 2 or 3 bottles = the compare-at if above the price, capped at
     n x the single price, else n x the single price (the Prism rule). Identical to bottle-main.liquid and snippets/bottle-upto. */
  function regOf(k) {
    var t = T[k]; if (!t) return 0;
    if (t.n === 1) return t.compare > t.price ? t.compare : t.price;
    var cap = t.n * SINGLE;
    return (t.compare > t.price && t.compare < cap) ? t.compare : cap;
  }
  function saveOf(k) { var s = T[k] ? regOf(k) - T[k].price : 0; return s > 0 ? s : 0; }
  function perUnit(k) { return Math.round(T[k].price / T[k].n); }
  function unitsWord(k) { var n = T[k].n; return n + (n === 1 ? ' bottle' : ' bottles'); }
  /* a deal is named only while the prices make it true: 50% off the second bottle to the cent (a half cent rounds up), and
     exactly two singles for three bottles */
  var DEAL = {
    1: '',
    2: T[1] && T[2] && Math.abs(2 * T[2].price - 3 * SINGLE) <= 2 ? 'Buy one, get one 50% off' : '',
    3: T[1] && T[3] && T[3].price === 2 * SINGLE ? 'Buy two, get one free' : ''
  };
  qsa('[data-deal]').forEach(function (d) { var t = DEAL[d.getAttribute('data-deal')] || ''; d.textContent = t; d.hidden = !t; });

  /* ---------- the store clock: the sale line and the Christmas lines can only switch OFF here ---------- */
  function storeToday() {
    var d = new Date(), s = '';
    try { s = new Intl.DateTimeFormat('en-CA', { timeZone: P.tz || 'America/Phoenix', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d); } catch (e) {}
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) s = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    return s;
  }
  var TODAY = storeToday();
  var UPTO = 0;
  [1, 2, 3].forEach(function (k) { var s = saveOf(k); if (s > 0) UPTO = Math.max(UPTO, Math.floor(s * 100 / regOf(k))); });
  /* "Preseason sale" only while the store's one dated sale runs (snippets/hh-sale-end, the kits' and /cart's date). The bundle
     discount itself is permanent, so with no date, or after it, the words are "Bundle & save" / "Bundle savings" (port audit 2026-10-20). */
  var saleEnd = String(P.saleEnd || '').trim();
  var saleOn = UPTO > 0;                           // Julian 2026-10-20: always "Preseason sale" while a bundle saves money (no end date shown)
  if (!saleOn) {                                   // the layout decided from the same date on the server; a cached page can outlive it
    var sl = D.querySelector('[data-sale-line]'), nl = D.querySelector('[data-nosale-line]');
    if (sl) sl.hidden = true; if (nl) nl.hidden = false;
  }
  var CUT = String(P.xmasCutoff || '').trim(), xmasLate = !CUT || TODAY > CUT;   // no cutoff on file = no Christmas line
  qsa('[data-xmas-yes]').forEach(function (el) { el.hidden = xmasLate; });
  qsa('[data-xmas-late]').forEach(function (el) { el.hidden = !xmasLate; });
  var orderBy = String(P.orderBy || '').trim();    // Julian's date. Empty = no "Order by" line anywhere
  qsa('[data-orderby]').forEach(function (el) { el.textContent = orderBy; });
  qsa('[data-orderby-line]').forEach(function (el) { el.hidden = !orderBy || xmasLate; });
  /* 60 days from delivery, delivery day = day 1: Dec 25 minus 59 days = Oct 27, every year */
  var CY = /^\d{4}/.test(CUT) ? CUT.slice(0, 4) : '', CF = CY ? CY + '-10-27' : '', XD = CY ? CY + '-12-25' : '';
  qsa('[data-xday-pre]').forEach(function (el) { el.hidden = !CF || TODAY >= CF; });
  qsa('[data-xday-now]').forEach(function (el) { el.hidden = !CF || TODAY < CF || TODAY > XD; });

  /* ---------- gallery ---------- */
  var slides = qsa('#stage .slide'), dotsEl = $('dots'), thumbs = qsa('#thumbs button'), cur = 0;
  /* Speed (v28): only picture 1 is in the HTML with a src. Pictures 2-10 carry data-src / data-srcset (bottle-main.liquid) and
     get their real src here: after the window load event (on idle), or at once when the shopper moves to one (that picture and
     its two neighbours). The slides are stacked in view, so loading="lazy" never held them back: all ten used to download with
     the hero (10.7 s on slow 4G). */
  function hydrate(k) {
    if (!slides.length) return;
    var im = slides[(k + slides.length) % slides.length].querySelector('img[data-src]');
    if (!im) return;
    var ss = im.getAttribute('data-srcset');
    if (ss) { im.setAttribute('srcset', ss); im.removeAttribute('data-srcset'); }
    im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src');
  }
  function hydrateAll() { slides.forEach(function (_, k) { hydrate(k); }); }
  function go(i, quiet) {                          // quiet: the first paint (picture 1 is already loading; leave the rest for later)
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    if (!quiet) { hydrate(cur); hydrate(cur + 1); hydrate(cur - 1); }
    slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
    var marks = (dotsEl ? [].slice.call(dotsEl.children) : []);
    [marks, thumbs].forEach(function (list) {
      list.forEach(function (b, k) { b.classList.toggle('on', k === cur); if (k === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    });
  }
  if (dotsEl) slides.forEach(function (_, i) {
    var d = D.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Picture ' + (i + 1) + ' of ' + slides.length);
    d.addEventListener('click', function () { go(i); }); dotsEl.appendChild(d);
  });
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
  qsa('.gnav').forEach(function (b) { b.hidden = slides.length < 2; b.addEventListener('click', function () { go(cur + Number(b.getAttribute('data-g'))); }); });
  var stage = $('stage'), sx = null, sy = null;
  if (stage) {
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; hydrate(cur + 1); hydrate(cur - 1); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));   // a sideways swipe, not a scroll
      sx = null;
    });
  }
  if (slides.length > 1) {
    var galleryLater = function () { if (window.requestIdleCallback) window.requestIdleCallback(hydrateAll, { timeout: 2500 }); else setTimeout(hydrateAll, 200); };
    if (D.readyState === 'complete') galleryLater(); else window.addEventListener('load', galleryLater);
  }

  /* ---------- tier selection ---------- */
  var tierEls = qsa('#tiers .tier'), sel = 0, touched = false;   // touched: the shopper picked a tier themselves
  tierEls.forEach(function (t) { var i = t.querySelector('input'); if (i && i.checked) sel = Number(t.getAttribute('data-q')); });
  if (!T[sel] || !T[sel].available) sel = [2, 3, 1].filter(function (k) { return T[k] && T[k].available; })[0] || (T[2] ? 2 : 0);

  function paintPrice() {
    var k = sel; if (!T[k]) return;
    var save = saveOf(k), was = $('wasPrice'), note = $('priceNote'), parts = [];
    $('fromPrice').textContent = money(T[k].price);                  // the big number is always the real total
    if (was) { was.textContent = save ? money(regOf(k)) : ''; was.hidden = !save; }
    if ($('plWhat')) $('plWhat').textContent = T[k].line;
    if (T[k].n > 1) { parts.push('That\'s ' + money(perUnit(k)) + ' a bottle.'); if (SINGLE) parts.push('One bottle is ' + money(SINGLE) + '.'); }
    if (note) { note.textContent = parts.join(' '); note.hidden = !parts.length; }
  }
  function select(k) {
    if (!T[k] || !T[k].available) return;
    sel = k;
    tierEls.forEach(function (t) { var on = Number(t.getAttribute('data-q')) === k; t.classList.toggle('on', on); var i = t.querySelector('input'); if (i) i.checked = on; });
    paintPrice(); paintAtc();
  }
  tierEls.forEach(function (t) {
    var k = Number(t.getAttribute('data-q')), i = t.querySelector('input');
    if (i) i.addEventListener('change', function () { if (i.checked) { touched = true; select(k); } });   // a tap on the card or the arrow keys
  });
  /* every "Choose your bottles" button: scroll to the three cards. Adds nothing. */
  function goPick() {
    var target = $('pick') || $('buy'); if (!target) return;
    target.scrollIntoView({ behavior: smooth(), block: 'start' });
    setTimeout(function () { focusOn(D.querySelector('#tiers .tier.on input')); }, 350);
  }

  /* ================= CART: Shopify's cart, drawn like the live Hearthside drawer ================= */
  var CART = null, busy = false, lastOpener = null;
  var ready = Promise.resolve();                   // the first-paint / Back-from-checkout read + tidy; every write waits for it
  var PROT = P.addons && P.addons.protection && P.addons.protection.id ? P.addons.protection : null;
  var WTY = P.addons && P.addons.warranty && P.addons.warranty.id ? P.addons.warranty : null;
  var PROP_K = 'Shipping protection', PROP_V = 'Included free';
  var FAIL = 'We couldn’t update your cart. Please try again.';
  var PRICE_MOVED = 'Prices just updated — refreshing the page.';
  var walnote = $('walnote'), WALNOTE = walnote ? walnote.textContent : '';
  var ICON_SHIELD = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.8 4.6 5.9v5.3c0 4.6 3.1 8.4 7.4 9.9 4.3-1.5 7.4-5.3 7.4-9.9V5.9L12 2.8Z"/><path d="m8.9 11.9 2.2 2.2 4.1-4.4"/></svg>';
  var ICON_MEDAL = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="14.6" r="5.4"/><path d="m8.6 9.6 -2.4-6.4h11.6l-2.4 6.4"/><path d="M12 12.2v4.8"/><path d="M10.2 14.6h3.6"/></svg>';

  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function okOrThrow(r) {
    if (r.ok) return r.json();
    return r.json().catch(function () { return null; }).then(function (j) { throw new Error((j && (j.description || j.message)) || FAIL); });
  }
  function refresh() {
    return fetch(P.routes.cartjs, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(FAIL); return r.json(); })
      .then(function (c) { CART = c; return c; });
  }
  function items() { return (CART && CART.items) || []; }
  function isBottle(it) { return Number(it.product_id) === Number(P.productId); }
  function addonTag(it) {
    if (PROT && Number(it.variant_id) === Number(PROT.id)) return 'protection';
    if (WTY && Number(it.variant_id) === Number(WTY.id)) return 'warranty';
    return '';
  }
  function sku(it) { return String((it && it.sku) || ''); }
  function isPrismLine(it) { return sku(it).indexOf('HH-PRISM') === 0; }
  function isPrismExtra(it) { return sku(it).indexOf('HH-PRISM-X') === 0; }
  function tierOfId(id) { for (var k = 1; k <= 3; k++) if (T[k] && T[k].id === Number(id)) return k; return 0; }
  function hasProp(it) { return !!(it && it.properties && it.properties[PROP_K] === PROP_V); }
  function bottleLines() { return items().filter(isBottle); }
  function freeTier() {                            // a 2- or 3-bottle tier in the cart: shipping protection is included free
    var best = 0;
    bottleLines().forEach(function (it) { var k = tierOfId(it.variant_id); if (k && T[k].n >= 2 && T[k].n > (best ? T[best].n : 0)) best = k; });
    return best;
  }
  function cartTier() {                            // 0 = no bottles; -1 = bottles that are not one plain tier line; else the tier
    var b = bottleLines(); if (!b.length) return 0;
    if (b.length !== 1 || Number(b[0].quantity) !== 1) return -1;
    return tierOfId(b[0].variant_id) || -1;
  }
  function isUpdate() { var c = cartTier(); return c !== 0 && c !== sel; }   // a different tier is already in the cart

  /* put the chosen tier in the cart, replacing any bottle line already there */
  function syncSet(k) {
    var t = T[k]; if (!t || !t.available) return Promise.reject(new Error(FAIL));
    var free = t.n >= 2;
    return refresh().then(function () {
      var have = bottleLines();
      var keep = have.filter(function (it) { return Number(it.variant_id) === t.id && hasProp(it) === free; })[0] || null;
      var upd = {}, need = false;
      have.forEach(function (it) { if (it !== keep) { upd[it.key] = 0; need = true; } });
      if (keep && Number(keep.quantity) !== 1) { upd[keep.key] = 1; need = true; }
      if (free) items().forEach(function (it) { if (addonTag(it) === 'protection') { upd[it.key] = 0; need = true; } });   // included free: never charge for it
      var item = { id: t.id, quantity: 1 };
      if (free) { item.properties = {}; item.properties[PROP_K] = PROP_V; }
      // add the new line first, then clear the old ones: if the add fails (sold out, network), the old cart is untouched
      var step = keep ? Promise.resolve() : post(P.routes.add, { items: [item] }).then(okOrThrow);
      return step.then(function () { return need ? post(P.routes.update, { updates: upd }).then(okOrThrow) : null; }).then(refresh);
    }).then(function (c) {
      var b = bottleLines();
      if (b.length !== 1 || Number(b[0].variant_id) !== t.id || Number(b[0].quantity) !== 1 || hasProp(b[0]) !== free) throw new Error(FAIL);
      // the button quoted a price; if Shopify now holds a different one for this variant, stop and reload
      if (Number(b[0].original_line_price) !== t.price) { var er = new Error(PRICE_MOVED); er.moved = true; throw er; }
      return c;
    });
  }
  /* add-ons never ride alone and are one per order; protection is free with 2 or 3 bottles; an Extra figure never rides alone */
  function tidy() {
    var list = items(), upd = {}, any = false, free = !!freeTier();
    var hasMain = list.some(function (it) { return !addonTag(it) && !isPrismExtra(it); });
    var hasPrismSet = list.some(function (it) { return isPrismLine(it) && !isPrismExtra(it); });
    list.forEach(function (it) {
      var tag = addonTag(it);
      if (tag && (!hasMain || (tag === 'protection' && free))) { upd[it.key] = 0; any = true; }
      else if (tag && Number(it.quantity) > 1) { upd[it.key] = 1; any = true; }
      else if (isPrismExtra(it) && !hasPrismSet) { upd[it.key] = 0; any = true; }
    });
    return any ? post(P.routes.update, { updates: upd }).then(okOrThrow).then(refresh) : Promise.resolve(CART);
  }
  /* the picker mirrors a bottle tier already in the cart (so "Update cart" means what it says) */
  function adoptCartTier() {
    if (touched) return;                           // never overwrite a choice the shopper already made
    var c = cartTier(); if (c > 0 && T[c] && T[c].available && c !== sel) select(c);
  }
  /* a bottle line is ONE line at quantity 1. A cart holding more (quantity 2 from an old page, or two bottle lines after a swap
     whose clearing step failed) becomes the tier for all its bottles, capped at three: Single x2 -> The Pair, Pair x2 -> The
     Family Set. Silent, on page load and Back from checkout only; never more bottles than the cart held, never a higher bill. */
  function normalizeBottles() {
    var b = bottleLines(), n = 0, known = true;
    if (!b.length || (b.length === 1 && Number(b[0].quantity) === 1)) return Promise.resolve();
    b.forEach(function (it) { var k = tierOfId(it.variant_id); if (k) n += T[k].n * (Number(it.quantity) || 0); else known = false; });
    var to = Math.min(3, n);
    if (!known || !T[to] || !T[to].available) return Promise.resolve();
    return syncSet(to).catch(function () { return refresh().catch(function () {}); });
  }

  function setBusy(on) {
    busy = on;
    ['hh-drawer', 'wallets'].forEach(function (id) { var nd = $(id); if (nd) { if (on) nd.setAttribute('aria-busy', 'true'); else nd.removeAttribute('aria-busy'); } });
    ['atc', 'stAtc'].forEach(function (id) { var b = $(id); if (b) { if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); } });
  }
  /* v28: every line counts except a Prism Extra figure (part of its set), the same rule as the kit drawer, the Prism drawer and
     /cart, so The Single + a paid shipping protection reads "2 items", as checkout says (it used to say 1). */
  function shownCount() { return items().reduce(function (a, it) { return a + (isPrismExtra(it) ? 0 : (Number(it.quantity) || 0)); }, 0); }
  function paintBadge() {
    var n = CART ? shownCount() : 0, el = $('cartN'), b = D.querySelector('.cartbtn');
    if (el) { el.hidden = !n; el.textContent = n; }
    if (b) b.setAttribute('aria-label', n ? 'Open cart, ' + n + (n === 1 ? ' item' : ' items') : 'Open cart');
  }
  function paintAtc() {
    var off = !T[sel] || !T[sel].available, txt = $('atcTxt'), st = $('stAtcTxt');
    if (txt) txt.textContent = off ? 'Sold out' : (isUpdate() ? 'Update cart — ' : 'Add to cart — ') + money(T[sel].price);
    if (st) st.textContent = off ? 'Sold out' : (isUpdate() ? 'Update cart' : 'Add to cart');
    [$('atc'), $('stAtc')].forEach(function (b) { if (b) b.classList.toggle('off', off); });
    paintSticky();
  }
  function lineCompare(it) {                       // per-unit "was" price in cents, only where it is honest to show it
    var k = isBottle(it) ? tierOfId(it.variant_id) : 0;
    if (!k) return 0;
    var r = regOf(k); return r > Number(it.price) ? r : 0;
  }
  function thumb(src, w) {
    if (!src) return '';
    src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  }
  function giftsLine(k) {
    if (!P.showGifts || !T[k] || T[k].n < 2) return '';
    return '<div class="hhci__v">Free: large-print recording guide' + (T[k].n >= 3 ? ' + spare battery pack + gift boxes for all three' : '') + '</div>';
  }
  /* the bottle stepper: kit look, but the number is bottles and each button swaps the tier. A tier that is sold out is skipped
     (plus goes to the next one that is not; with none below, the minus is the delete icon), so a button never offers what
     Shopify would refuse. Disabled while a write is in flight. */
  function stepUp(k) { for (var j = k + 1; j <= 3; j++) if (T[j] && T[j].available) return j; return 0; }
  function stepDown(k) { for (var j = k - 1; j >= 1; j--) if (T[j] && T[j].available) return j; return 0; }
  function bottleStep(k) {
    var up = stepUp(k), dn = stepDown(k), off = busy ? ' disabled' : '';
    var minus = dn
      ? '<button class="hhci__b" type="button" data-hh-bstep="' + dn + '" data-dir="down" aria-label="Fewer bottles: switch to ' + esc(T[dn].name) + ', ' + unitsWord(dn) + '"' + off + '>&minus;</button>'
      : '<button class="hhci__b" type="button" data-hh-rm data-dir="down" aria-label="' + (T[k].n === 1 ? 'Remove your bottle' : 'Remove your bottles') + '"' + off + '><span class="ms" aria-hidden="true">delete</span></button>';
    var plus = up
      ? '<button class="hhci__b" type="button" data-hh-bstep="' + up + '" data-dir="up" aria-label="More bottles: switch to ' + esc(T[up].name) + ', ' + unitsWord(up) + '"' + off + '>+</button>'
      : '<button class="hhci__b" type="button" data-dir="up" disabled aria-label="' + (k >= 3 || !T[k + 1] ? 'Three bottles is the biggest set' : esc(T[k + 1].name) + ' is sold out right now') + '">+</button>';
    return '<span class="hhci__step" data-hh-bottle>' + minus +
             '<input class="hhci__n" type="text" value="' + T[k].n + '" readonly tabindex="-1" aria-label="Bottles">' + plus + '</span>';
  }
  function rowHTML(it) {
    var qty = Number(it.quantity) || 0, tag = addonTag(it), cmp = lineCompare(it), im, vt = '', ctl = '', extra = '';
    var price = (cmp ? '<s>' + money(cmp * qty) + '</s>' : '') + money(it.final_line_price);
    if (isBottle(it)) {
      var k = tierOfId(it.variant_id);
      vt = k ? T[k].name + ' · ' + unitsWord(k) + (qty > 1 ? ' · × ' + qty : '') : ((it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '');
      extra = k ? giftsLine(k) : '';
      im = '<div class="hhci__im is-thumb"><span class="gbthumb mbthumb" aria-hidden="true"></span></div>';
      ctl = k ? bottleStep(k) : '<button class="hhci__rm" type="button" data-hh-rm aria-label="Remove your bottles">Remove</button>';
    } else if (tag) {
      im = '<div class="hhci__im is-icon">' + (tag === 'protection' ? ICON_SHIELD : ICON_MEDAL) + '</div>';
      ctl = '<button class="hhci__rm" type="button" data-hh-q="0" aria-label="Remove ' + esc(it.product_title) + '">Remove</button>';
    } else if (isPrismLine(it)) {                  // the Prism page sells sets, so no stepper here either (its page has Edit)
      var hasSet = items().some(function (x) { return isPrismLine(x) && !isPrismExtra(x); });
      vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      if (isPrismExtra(it)) vt = 'Extra ' + vt + (qty > 1 ? ' × ' + qty : '') + (hasSet ? ' · part of your set' : '');
      else if (qty > 1) vt += ' · × ' + qty;
      im = '<div class="hhci__im">' + (it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" loading="lazy">' : '<span class="ms" aria-hidden="true">redeem</span>') + '</div>';
      ctl = isPrismExtra(it) && hasSet ? '' : '<button class="hhci__rm" type="button" data-hh-prism-rm aria-label="Remove your Prism Tree set">Remove</button>';
    } else {                                       // tree kits: each pack is a real variant, so a stepper bills qty x that pack
      vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      im = '<div class="hhci__im">' + (it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" loading="lazy">' : '<span class="ms" aria-hidden="true">redeem</span>') + '</div>';
      ctl = '<span class="hhci__step">' +
              '<button class="hhci__b" type="button" data-hh-q="' + (qty - 1) + '" aria-label="' + (qty > 1 ? 'Decrease quantity' : 'Remove this item') + '">' + (qty > 1 ? '&minus;' : '<span class="ms" aria-hidden="true">delete</span>') + '</button>' +
              '<input class="hhci__n" type="number" inputmode="numeric" min="1" max="10" value="' + qty + '" data-hh-qty aria-label="Quantity">' +
              '<button class="hhci__b" type="button" data-hh-q="' + (qty + 1) + '" aria-label="Increase quantity"' + (qty >= 10 ? ' disabled' : '') + '>+</button>' +
            '</span>';
    }
    return '<div class="hhci" data-hh-key="' + esc(it.key) + '">' + im +
             '<div class="hhci__d"><div class="hhci__t">' + esc(it.product_title) + '</div>' + (vt ? '<div class="hhci__v">' + esc(vt) + '</div>' : '') + extra +
               (ctl ? '<div class="hhci__c">' + ctl + '</div>' : '') + '</div>' +
             '<div class="hhci__p">' + price + '</div>' +
           '</div>';
  }
  function freeProtRow(k) {
    return '<div class="hhci"><div class="hhci__im is-icon">' + ICON_SHIELD + '</div>' +
             '<div class="hhci__d"><div class="hhci__t">Shipping protection</div><div class="hhci__v">Included free with ' + esc(T[k].name) + '</div></div>' +
             '<div class="hhci__p">' + (PROT ? '<s>' + money(PROT.price) + '</s>' : '') + '<span class="free">Free</span></div>' +
           '</div>';
  }
  function renderCart() {
    var list = items(), n = list.length, ft = freeTier();
    var bottles = list.filter(isBottle), addons = list.filter(function (it) { return !!addonTag(it); }),
        prism = list.filter(function (it) { return !isBottle(it) && !addonTag(it) && isPrismLine(it); }),
        others = list.filter(function (it) { return !isBottle(it) && !addonTag(it) && !isPrismLine(it); });
    var saved = bottles.reduce(function (a, it) { var c = lineCompare(it); return a + (c ? (c - Number(it.price)) * (Number(it.quantity) || 0) : 0); }, 0);
    var h;
    if (!n) h = '<div class="hhcart__empty"><span class="ms" aria-hidden="true">shopping_bag</span><p>Your cart is empty.</p><p class="s">Pick your bottles to get started.</p>' +
                '<button class="hhcart__link" type="button" data-hh-shop>Choose your bottles</button></div>';
    else h = bottles.map(rowHTML).join('') + (ft ? freeProtRow(ft) : '') + prism.concat(others, addons).map(rowHTML).join('');
    $('hh-lines').innerHTML = h;
    var sc = shownCount(); $('hh-count').textContent = sc ? ' · ' + sc + (sc === 1 ? ' item' : ' items') : '';
    $('hh-total').textContent = money(CART ? Number(CART.items_subtotal_price) || 0 : 0);
    $('hh-save').hidden = !(saved > 0); $('hh-savev').textContent = saved > 0 ? '−' + money(saved) : '';
    var go2 = $('hh-checkout'); go2.disabled = !n || busy;
    var ship = $('hh-ship'); ship.textContent = n ? 'Free' : '—'; ship.className = n ? 'is-free' : '';
    var urg = $('hh-urg');
    if (!n) urg.hidden = true;
    else {
      $('hh-urgt').innerHTML = saved > 0 ? '<span class="hhcart__saletag"><span class="ms" aria-hidden="true">' + (saleOn ? 'local_offer' : 'redeem') + '</span> ' + (saleOn ? 'Early Black Friday deals' : 'Bundle savings') + '</span>' +
        '<span class="hhcart__saletxt">You\'re saving <b>' + money(saved) + '</b> on this order.</span>' : '';
      $('hh-urgs').innerHTML = '<span class="ms" aria-hidden="true">check</span> Free shipping included on your order.';
      urg.hidden = false;
    }
    /* the one optional add-on: shipping protection, unticked until she ticks it; gone when 2 or 3 bottles include it free */
    var hasMain = bottles.length + prism.length + others.length > 0;
    if (PROT && hasMain && !ft) {
      var on = addons.some(function (a) { return addonTag(a) === 'protection'; });
      $('hh-upslist').innerHTML = '<label class="hhup' + (on ? ' on' : '') + '" data-hh-up="protection"><input type="checkbox"' + (on ? ' checked' : '') + (busy ? ' disabled' : '') + '>' +
        '<span class="hhup__ico">' + ICON_SHIELD + '</span><span class="hhup__box"><span class="ms" aria-hidden="true">check</span></span>' +
        '<span class="hhup__t"><b>Shipping protection</b><small>If your package is lost or stolen on the way, we send another one.</small></span>' +
        '<span class="hhup__p">+' + money(PROT.price) + '</span></label>';
      $('hh-ups').hidden = false;
    } else { $('hh-upslist').innerHTML = ''; $('hh-ups').hidden = true; }
    paintBadge(); paintAtc();
  }

  var BEHIND = '.banner,header.site,main,footer.site-foot,#sticky';
  function behindInert(on) { qsa(BEHIND).forEach(function (nd) { if (on) nd.setAttribute('inert', ''); else nd.removeAttribute('inert'); }); }
  function cartOpen() { return $('hh-drawer').classList.contains('on'); }
  function openCart(opener) {
    lastOpener = (opener && opener !== B) ? opener : $('atc');      // Safari doesn't focus clicked buttons
    renderCart(); behindInert(true);
    $('hh-scrim').classList.add('on');
    var dr = $('hh-drawer'); dr.classList.add('on'); dr.setAttribute('aria-hidden', 'false');
    focusOn($('hh-close'));
  }
  function closeCart() {
    $('hh-scrim').classList.remove('on');
    var dr = $('hh-drawer'); dr.classList.remove('on'); dr.setAttribute('aria-hidden', 'true');
    behindInert(false);                            // before refocusing: focus() on an inert element silently fails
    if (lastOpener && D.contains(lastOpener)) focusOn(lastOpener);
  }
  function run(p, after) {                         // one write in flight; the drawer dims, never blanks; tidy after every write
    if (busy) return Promise.resolve();
    setBusy(true); renderCart();
    return ready.then(p).then(tidy).catch(function (err) { say((err && err.message) || FAIL); if (err && err.moved) return null; return refresh().catch(function () {}); })
      .then(function () { setBusy(false); renderCart(); if (after) after(); });
  }

  function addSet(e) {                             // main + sticky button: put the chosen tier in the cart, open the drawer
    if (!T[sel] || !T[sel].available) { say('This one is sold out right now.'); return; }
    var opener = e && e.currentTarget, moved = false, failed = false, k = sel, before = cartSig();
    touched = true;                                // she accepted the tier on the button: never flip the picker away from it
    run(function () { return syncSet(k).catch(function (err) { failed = true; if (err && err.moved) moved = true; throw err; }); },
        function () {
          if (moved) setTimeout(function () { location.reload(); }, 1200);
          // a refused add (draft, sold out, network) left the cart as it was: stay on the page with the message, like the express
          // buttons. If the cart did change (the add went in but clearing the old line failed), open it so she sees the true cart.
          else if (!failed || cartSig() !== before) openCart(opener);
        });
  }
  function cartSig() { return items().map(function (it) { return it.key + ':' + it.quantity; }).join('|'); }
  function expressBuy() {                          // the four wallet buttons: the same tier, then straight to checkout
    if (!T[sel] || !T[sel].available) { say('This one is sold out right now.'); return; }
    if (busy) return;
    if (walnote) { walnote.textContent = 'Taking you to checkout…'; walnote.classList.add('fired'); }
    setBusy(true); touched = true;
    var k = sel;
    ready.then(function () { return syncSet(k); }).then(tidy).then(function () { location.href = P.routes.checkout; })
      .catch(function (err) {
        say((err && err.message) || FAIL);
        if (err && err.moved) { setTimeout(function () { location.reload(); }, 1200); return; }
        setBusy(false); if (walnote) { walnote.textContent = WALNOTE; walnote.classList.remove('fired'); }
        refresh().catch(function () {}).then(renderCart);
      });
  }
  function goCheckout() {
    if (busy || !items().length) return;
    var b = $('hh-checkout'); if (b) { b.disabled = true; b.innerHTML = '<span class="ms" aria-hidden="true">lock</span> Taking you to checkout…'; }
    location.href = P.routes.checkout;
  }
  function removeBottles() {
    var upd = {}; bottleLines().forEach(function (it) { upd[it.key] = 0; });
    if (!Object.keys(upd).length) return;
    run(function () { return post(P.routes.update, { updates: upd }).then(okOrThrow).then(refresh); },
        function () { focusOn(D.querySelector('[data-hh-shop]') || $('hh-close')); });
  }
  function stepBottle(k, dir) {                    // the drawer stepper: swap the one bottle line to tier k (the same write as Add)
    if (busy || !T[k] || !T[k].available) return;
    var moved = false, done = false;
    run(function () { return syncSet(k).then(function () { done = true; }, function (err) { if (err && err.moved) moved = true; throw err; }); },
        function () {
          if (moved) { setTimeout(function () { location.reload(); }, 1200); return; }
          if (done) { touched = true; select(k); }  // the picker follows what she chose in the drawer
          var st = $('hh-lines').querySelector('[data-hh-bottle]');   // the line was re-drawn (new key): focus the same button
          focusOn((st && (st.querySelector('[data-dir="' + dir + '"]:not([disabled])') || st.querySelector('.hhci__b:not([disabled])'))) || $('hh-close'));
        });
  }
  function removePrism() {
    var upd = {}; items().filter(isPrismLine).forEach(function (it) { upd[it.key] = 0; });
    if (!Object.keys(upd).length) return;
    run(function () { return post(P.routes.update, { updates: upd }).then(okOrThrow).then(refresh); }, function () { focusOn($('hh-close')); });
  }
  function changeLine(key, qn) {
    qn = Math.round(Number(qn));
    if (!isFinite(qn)) { renderCart(); return; }
    qn = Math.max(0, Math.min(10, qn));
    run(function () { return post(P.routes.change, { id: String(key), quantity: qn }).then(okOrThrow).then(function (c) { CART = c; }); },
        function () {                              // the clicked button was re-drawn: keep keyboard focus inside the drawer
          var row = $('hh-lines').querySelector('[data-hh-key="' + String(key).replace(/"/g, '') + '"]'), b = row && row.querySelector('.hhci__b:not([disabled]), .hhci__rm');
          focusOn(b || $('hh-close'));
        });
  }
  function toggleProtection(want) {
    if (!PROT) return;
    function refocus() { focusOn($('hh-upslist').querySelector('[data-hh-up] input') || $('hh-close')); }
    var have = items().filter(function (it) { return addonTag(it) === 'protection'; })[0];
    if (want && !have && !freeTier()) run(function () { return post(P.routes.add, { items: [{ id: Number(PROT.id), quantity: 1 }] }).then(okOrThrow).then(refresh); }, refocus);
    else if (!want && have) run(function () { return post(P.routes.change, { id: String(have.key), quantity: 0 }).then(okOrThrow).then(function (c) { CART = c; }); }, refocus);
    else { renderCart(); refocus(); }
  }

  var atcBtn = $('atc'), stAtc = $('stAtc');
  if (atcBtn) atcBtn.addEventListener('click', addSet);
  if (stAtc) stAtc.addEventListener('click', addSet);
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var q = t.closest('[data-stq]'); if (q) { touched = true; select(Number(q.getAttribute('data-stq'))); return; }
    if (t.closest('[data-hh-buy]')) { e.preventDefault(); expressBuy(); return; }
    var op = t.closest('[data-hh-open]'); if (op) { refresh().catch(function () {}).then(function () { openCart(op); }); return; }
    if (t.closest('#hh-close') || t.closest('#hh-scrim')) { closeCart(); return; }
    if (t.closest('[data-choose]')) { e.preventDefault(); goPick(); return; }
    if (busy) return;
    if (t.closest('#hh-checkout')) { goCheckout(); return; }
    var bs = t.closest('[data-hh-bstep]'); if (bs) { if (!bs.disabled) stepBottle(Number(bs.getAttribute('data-hh-bstep')), bs.getAttribute('data-dir')); return; }
    if (t.closest('[data-hh-rm]')) { removeBottles(); return; }
    if (t.closest('[data-hh-prism-rm]')) { removePrism(); return; }
    if (t.closest('[data-hh-shop]')) { closeCart(); goPick(); return; }
    var qb = t.closest('[data-hh-q]'); if (qb) { var row = qb.closest('[data-hh-key]'); if (row) changeLine(row.getAttribute('data-hh-key'), qb.getAttribute('data-hh-q')); }
  });
  D.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('[data-hh-up]')) { if (busy) { renderCart(); return; } toggleProtection(!!t.checked); return; }
    if (t.hasAttribute && t.hasAttribute('data-hh-qty')) {   // a cleared or zero box reverts, it never deletes
      var row = t.closest('[data-hh-key]'); if (!row) return;
      var v = Math.round(Number(t.value)); if (!isFinite(v) || v < 1) { renderCart(); return; }
      changeLine(row.getAttribute('data-hh-key'), Math.min(10, v));
    }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cartOpen()) closeCart(); });

  /* ---------- sticky bar ----------
     Desktop: only after the main button has scrolled away above (the Prism rule).
     Phone: also before she reaches the button. Until the three cards arrive it is in "quick" mode (the three tier chips, which
     move the main selection too, the product name, the price with compare-at and Add to cart), so the first screen has all of
     them. From the cards on it is in "buy" mode: the chosen tier and Add to cart. */
  var sticky = $('sticky'), stKey = '', stH = 0;
  function paintSticky() {
    if (!sticky || !T[sel]) return;
    var mode = sticky.getAttribute('data-mode') === 'quick' ? 'quick' : 'buy';
    var key = [mode, sel, cartTier()].join('|'); if (key === stKey) return; stKey = key;
    var save = saveOf(sel);
    qsa('[data-stq]').forEach(function (b) { b.setAttribute('aria-checked', Number(b.getAttribute('data-stq')) === sel ? 'true' : 'false'); });
    if (mode === 'quick') {
      $('stName').textContent = P.title || '';
      $('stSub').innerHTML = money(T[sel].price) + (save ? ' <s>' + money(regOf(sel)) + '</s>' : '') + '<span class="st-ship"> · Includes free shipping</span>';
    } else {
      $('stName').textContent = T[sel].name;
      $('stSub').innerHTML = unitsWord(sel) + ' — ' + money(T[sel].price) + (save ? ' <s>' + money(regOf(sel)) + '</s>' : '');
    }
  }
  function syncSticky() {
    if (!sticky || !atcBtn) return;
    var r = atcBtn.getBoundingClientRect();
    var above = r.bottom < 0;                      // she has scrolled past the main button
    var below = r.top > window.innerHeight;        // she has not reached it yet
    var phone = mq('(max-width:900px)');
    var on = above || (phone && below);
    var pickEl = $('pick'), pickTop = pickEl ? pickEl.getBoundingClientRect().top : 0;
    var quick = phone && below && pickTop > window.innerHeight * 0.6;   // the three cards have not arrived yet
    sticky.classList.toggle('on', on);
    sticky.setAttribute('data-mode', quick ? 'quick' : 'buy');
    paintSticky();
    B.classList.toggle('sticky-on', on);           // lifts the toast clear of the bar
    if (on) { var h = sticky.offsetHeight; if (h && h !== stH) { stH = h; D.documentElement.style.setProperty('--sticky-h', h + 'px'); } }
  }
  window.addEventListener('scroll', syncSticky, { passive: true });
  window.addEventListener('resize', syncSticky);

  /* accordions: <details> already tells assistive tech its state; aria-expanded on the summary keeps the two in step */
  qsa('details').forEach(function (d) {
    var s = d.querySelector('summary'); if (!s) return;
    s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    d.addEventListener('toggle', function () { s.setAttribute('aria-expanded', d.open ? 'true' : 'false'); });
  });

  /* Back from checkout restores this page from the bfcache with busy still set: reset it and re-read the cart */
  var GOHTML = $('hh-checkout') ? $('hh-checkout').innerHTML : '';
  window.addEventListener('pageshow', function (e) {
    syncSticky();
    if (!e.persisted) return;
    setBusy(false);
    if (walnote) { walnote.textContent = WALNOTE; walnote.classList.remove('fired'); }
    var gb = $('hh-checkout'); if (gb && GOHTML) gb.innerHTML = GOHTML;
    ready = refresh().then(tidy).then(normalizeBottles).catch(function () {}).then(renderCart);
  });

  /* ---------- first paint ---------- */
  if (T[sel]) select(sel); else paintAtc();
  go(0, true);
  renderCart(); syncSticky();
  ready = refresh().then(tidy).then(normalizeBottles).then(function () { adoptCartTier(); renderCart(); }).catch(function () { renderCart(); });
})();

